import React, { useState ,useEffect } from "react";
import StoreTextBox from "../components/TextBox/StoreTextBox"
import { useParams } from "react-router-dom";
import API from "../utils/API";
import ShopMenu from "../components/MenuBtns/ShopMenu";
import MusicBtn from "../components/SoundBtns/MusicBtn";
import "../components/Store/Store.css";

function ForestStore() {

    const { id } = useParams();

    const [userData, setUserData] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const [loadError, setLoadError] = useState("")

    useEffect(() => {
        // API.getUserSprite(id).then(user => {
        //     const { sprite } = user.data[0].sprite[0]
       
        //         return setUserAvatar(sprite)
        // }).then(() => {API.getUserSprite(id).then(user => {
        //     const { name } = user.data[0].sprite[0]
       
        //     setUserAvatarName(name)
        // })
            
        // }).then(()=>{
        //     API.getUserSprite(id).then(user => {
        //         const {money} = user.data[0].sprite[0]
        //         return setUserMoney(money)
        //     })
        // })

        const getUserData = async ()=> {
            const userData = await API.getUser(id)
            const user = await userData.json()
            setUserData(user)
            setIsLoading(false)
        }
  

        getUserData().catch(() => {
            setLoadError("We could not load the shop. Please refresh and try again.")
            setIsLoading(false)
        })
    }, [id]);

    if (isLoading) return <div className="world-map-loading" role="status">Loading the shop…</div>
    if (loadError) return <div className="world-map-loading" role="alert">{loadError}</div>

    return(
        <main className="shop-page">
            <MusicBtn user={userData} />
            <h1 className="text-center">Erik's Shop</h1>
            <div className="shop-layout">
                <StoreTextBox user={userData} />
            </div>
            <ShopMenu />
        </main>
    )
}

export default ForestStore;